import { fmtTime } from 'TimeOffList/services/format';

export const DEFAULT_TIME_STEP_MIN = 15;
const DAY_MIN = 24 * 60;
const OPT_START = 6 * 60; // 6:00 AM
const OPT_END = 22 * 60; // 10:00 PM

/** Clamp to [0, 23:45-ish] respecting the step (so max = lastValidStep). */
export const clampMin = (v: number, step: number): number => Math.max(0, Math.min(DAY_MIN - step, v));

export interface TimeOption {
  value: number;
  label: string;
}

/** Dropdown options 6:00 AM–10:00 PM at the given step. */
export const buildTimeOptions = (step: number): TimeOption[] => {
  const opts: TimeOption[] = [];
  for (let t = OPT_START; t <= OPT_END; t += step) {
    opts.push({ value: t, label: fmtTime(t) });
  }
  return opts;
};
